(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-caffeine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(el) {
      if (!el || el.dataset.cfCafReady || reduce || !('IntersectionObserver' in window)) return;
      el.dataset.cfCafReady = '1';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85) return;
      el.classList.add('is-pending');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { el.classList.remove('is-pending'); io.disconnect(); }
        });
      }, { threshold: 0.25 });
      io.observe(el);
    }
    function run() { document.querySelectorAll('[data-cf-caf]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-video-bubble"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (!root || root.dataset.cfVbReady) return;
      root.dataset.cfVbReady = '1';
      var key = 'cf-vb-hidden-' + root.dataset.key;
      var design = window.Shopify && window.Shopify.designMode;
      if (!design) {
        try { if (sessionStorage.getItem(key)) { root.hidden = true; return; } } catch (e) {}
      }
      var openBtn = root.querySelector('[data-open]');
      var dlg = root.querySelector('dialog');
      var full = dlg ? dlg.querySelector('video') : null;
      var prev = root.querySelector('.cf-vb__preview');
      var clip = parseFloat(root.dataset.clip) || 6;

      function playPrev() {
        if (!prev || reduce || root.hidden) return;
        if (!prev.getAttribute('src') && prev.dataset.src) prev.src = prev.dataset.src;
        var p = prev.play();
        if (p && p.catch) p.catch(function () {});
      }

      if (prev) {
        prev.muted = true;
        prev.addEventListener('timeupdate', function () { if (prev.currentTime > clip) prev.currentTime = 0; });
        var start = function () { setTimeout(playPrev, 1200); };
        if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
      }

      if (openBtn && dlg) {
        openBtn.addEventListener('click', function () {
          if (prev) prev.pause();
          if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
          document.documentElement.classList.add('cf-vb-lock');
          if (full) {
            try { full.currentTime = 0; } catch (e) {}
            full.muted = false;
            var p = full.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
        var onClose = function () {
          if (full) full.pause();
          document.documentElement.classList.remove('cf-vb-lock');
          playPrev();
          openBtn.focus();
        };
        dlg.addEventListener('close', onClose);
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        var closeBtn = dlg.querySelector('[data-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () {
          if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); onClose(); }
        });
      }

      var dismiss = root.querySelector('[data-dismiss]');
      if (dismiss) dismiss.addEventListener('click', function () {
        if (prev) prev.pause();
        root.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
      });
    }

    function run() { document.querySelectorAll('[data-cf-vb]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-video-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(player) {
      if (!player || player.dataset.cfVfReady) return;
      player.dataset.cfVfReady = '1';
      var video = player.querySelector('video');
      var btn = player.querySelector('[data-play]');
      if (!video || !btn) return;
      var start = function () {
        player.classList.add('is-playing');
        video.controls = true;
      };
      btn.addEventListener('click', function () {
        start();
        var p = video.play();
        if (p && p.catch) p.catch(function () { player.classList.remove('is-playing'); });
        try { video.focus({ preventScroll: true }); } catch (e) {}
      });
      video.addEventListener('play', start);
    }
    function run() { document.querySelectorAll('[data-cf-vf]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
